import { css } from 'styled-components';

export const StyledLink = ({ theme }) => css`
    font-weight: ${theme.fontWeights.semiBold};
`;

export const StageHeading = ({ theme }) => css`
    color: ${theme.colors.global.white};
    background-color: #27314a;
`;

export const LoadingSpinnerBranded = ({ theme }) => css`
    color: ${theme.colors.global.white};
`;

export const CardContainer = css`
    background: linear-gradient(155deg, #ff8791 7.72%, #ffe433 102.75%);
`;

export const TitleSection = ({ theme }) => css`
    background-color: ${theme.colors.capitalOne.blue750};
`;
